import queryString from "query-string"

export function ReturnSessionLink(sessionName) {
  const parameter = queryString.stringify({
    session: sessionName,
  })
  const url = "https://activeemdr.com/client?" + parameter
  return url
}
